import Layout from '@/pages/Layout';

export default [
    {
        path: '/message',
        redirect: 'noredirect',
        component: Layout,
        name: 'message',
        meta: {
            title: '消息中心',
            icon: 'el-icon-message-solid'
        },
        children: [
            {
                path: 'warnMessage',
                component: () => import('@/pages/message/WarnMessage'),
                name: 'warnMessage',
                id: 'message/warnMessage',
                meta: {
                    title: '预警消息',
                    icon: 'iconfont icon-other-jinggaotishijingbaoyujing bc-custom-menu',
                    color: '#fe3d00'
                },
                isMenuWaterfall: true
            },
            {
                path: 'urgeMessage',
                component: () => import('@/pages/message/UrgeMessage'),
                name: 'urgeMessage',
                id: 'message/urgeMessage',
                meta: {
                    title: '催办消息',
                    icon: 'iconfont icon-other-daibanshixiang bc-custom-menu',
                    color: '#fe3d00'
                },
                isMenuWaterfall: true
            },
            {
                path: 'allMessage',
                component: () => import('@/pages/message/AllMessage'),
                name: 'allMessage',
                id: 'message/allMessage',
                meta: {
                    title: '全部消息',
                    icon: 'iconfont icon-other-xiazai41 bc-custom-menu',
                    color: '#e6cc14'
                },
                isMenuWaterfall: true
            },
            {
                path: 'unreadMessage',
                component: () => import('@/pages/message/UnReadMessage'),
                name: 'unreadMessage',
                id: 'message/unreadMessage',
                meta: {
                    title: '未读消息',
                    icon: 'iconfont icon-other-weiduxiaoxi-05 bc-custom-menu',
                    color: '#1b8f06'
                },
                isMenuWaterfall: true
            },
            {
                path: 'readMessage',
                component: () => import('@/pages/message/ReadMessage'),
                name: 'readMessage',
                id: 'message/readMessage',
                meta: {
                    title: '已读消息',
                    icon: 'iconfont icon-other-yiduxiaoxi bc-custom-menu',
                    color: '#34b4c9'
                },
                isMenuWaterfall: true
            },
            {
                path: 'message/:messageId',
                component: () => import('@/pages/message/Message'),
                isShow: false,
                name: 'messageDetail',
                id: 'message/message/:messageId',
                meta: {
                    title: '消息详情',
                    icon: 'table'

                },
                isMenuWaterfall: false
            },
            {
                path: 'messageDesignTitle',
                name: 'messageDesignTitle',
                id: 'messageDesignTitle',
                meta: {
                    title: '消息设计',
                    icon: 'iconfont icon-other-xiaoxishezhi1 bc-custom-menu',
                    color: '#77ba1d'
                },
                sortOrder: 60,
                isDesign: true,
                isTitle: true,
                isShow: false,
                isMenuWaterfall: true
            },
            {
                pId: 'messageDesignTitle',
                path: 'messageTemplateReceiverList',
                component: () => import('@/pages/message/MessageTemplateList'),
                name: 'messageTemplateReceiverList',
                id: 'message/messageTemplateReceiverList',
                meta: {
                    title: '消息接收设置',
                    icon: 'iconfont icon-other-xiaoxishezhi bc-custom-menu',
                    color: '#6aa669'
                },
                sortOrder: 61,
                isDesign: true,
                isSubMenu: true,
                isMenuWaterfall: true
            },
            {
                path: 'msgTemplateReceiverSet/:messageTemplateId',
                component: () => import('@/pages/message/MessageReceiverSet'),
                isShow: false,
                name: 'msgTemplateReceiverSet',
                id: 'message/msgTemplateReceiverSet/:messageTemplateId',
                meta: {
                    title: '消息接收人修改',
                    icon: 'table'
                },
                isMenuWaterfall: false
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/route-message.js